import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';

export const StyledLottiePlayer = styled(Lottie, {
  shouldForwardProp: (prop) => prop !== 'fillContainer',
})(({ fillContainer = false }: { fillContainer?: boolean }) => {
  const defaultStyles = css`
    ${fillContainer &&
    css`
      width: 100%;
      height: 100%;

      & > svg {
        width: 100%;
        height: 100%;
      }
    `}
  `;

  return [defaultStyles];
});
